import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-form p-component'
};

export default BaseStyle.extend({
    name: 'form',
    classes
});
